import {BrowserRouter, Routes, Route, Link} from 'react-router-dom';
import './App.css';
import ListUser from './components/ListUser';
import CreateUser from './components/CreateUser';
import EditUser from './components/EditUser';

function App() {
  return (
    <div className="App">
      <center>
      <h2>React CRUD Operations using PHP</h2>
      <BrowserRouter>
      <nav>
        <ul>
          <li>
            <Link to="/">List Users</Link>
          </li>
          <li>
            <Link to="user/create">Create Users</Link>
          </li>
        </ul>
      </nav>
      
      <Routes>
      <Route index element={<ListUser />} />
      <Route path="user/create" element={<CreateUser />} />
      <Route path="user/:id/edit" element={<EditUser />} />

      </Routes>
      </BrowserRouter>
      </center>
    </div>
  );
}

export default App;
